import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Autocomplete } from '@material-ui/lab'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import { makeStyles } from '@material-ui/core'
import { isEmpty, filter, includes } from 'ramda'
import effects from 'app/effects/effects'
import { useIntl } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  endAdornment: {
    width: '100%',
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
  },
}))

const PreferredLanguageSelector = ({
  value,
  onChange,
  placeholder,
  className,
  options,
  error,
  helperText,
}) => {
  const { formatMessage } = useIntl()
  const classes = useStyles()

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) =>
        value === 1 ? `${option.name}` : `${option.nativeName} - ${option.name}`
      }
      value={options.find((language) => language.id === value) || null}
      className={className}
      renderOption={(option) => {
        return (
          <div>
            <div>{option.nativeName}</div>
            <div>{option.name}</div>
          </div>
        )
      }}
      noOptionsText={formatMessage({
        id: 'crm.form.receiveMethods.option.empty',
      })}
      onChange={(event, newValue) => {
        if (onChange) {
          onChange(newValue ? newValue.id : null)
        }
      }}
      renderInput={(params) => (
        <div ref={params.InputProps.ref} className="w-full">
          <SimpleInput
            id="preferredLanguage"
            placeholder={placeholder}
            endAdornment={
              <div className={classes.endAdornment}>
                {params.InputProps.endAdornment}
              </div>
            }
            size="medium"
            fullWidth
            error={error}
            helperText={helperText}
            {...params}
          />
        </div>
      )}
    />
  )
}

PreferredLanguageSelector.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
}

export default PreferredLanguageSelector
